/**
 * Process any leftover text in the input field before form submission.
 * Validates character length, deduplicates, and respects max limits.
 *
 * @returns Updated list with leftover items added, or `null` if validation failed.
 */
export const processLeftoverInput = (
  input: string,
  existingList: string[],
  setErrorState: (error: any) => void,
  maxLimit: number = 3,
  itemLabel: string = 'Competitor name'
): string[] | null => {
  const trimmed = input.trim();
  if (!trimmed) return existingList;

  const parts = trimmed.includes(',')
    ? trimmed
        .split(',')
        .map((p) => p.trim())
        .filter(Boolean)
    : [trimmed];

  const updatedList = [...existingList];
  for (const part of parts) {
    if (part.length > 50) {
      setErrorState({
        open: true,
        message: `${itemLabel} cannot exceed 50 characters`
      });
      return null;
    }
    if (updatedList.length < maxLimit && !updatedList.includes(part)) {
      updatedList.push(part);
    }
  }
  return updatedList;
};
